// extracted by mini-css-extract-plugin
export default {"title":"T9-z","warning":"U9-z","sizeOptionsLegendText":"V9-z"};